import type { Component, VectorImageData } from '@wix/thunderbolt-becky-types'
import { createCompNode } from '@wix/thunderbolt-catharsis'
import { getFontFamilyFontsFromSvg } from '@wix/thunderbolt-commons'
import type { ResolvedSvgDataItem } from '../../../types'
import { EMPTY_ARRAY } from '../../../utils/constants'
import type { FeatureRefs } from '../../cssFeatures.types'

export const svgImageFontFamilies = {
	predicate: (component: Component) => component.componentType === 'SvgImage',
	compNode: createCompNode({
		getDependencies: (component: Component, refs: FeatureRefs<'fontFaces'>) =>
			refs.dataQuery<ResolvedSvgDataItem<VectorImageData>>(component.dataQuery!),
		toViewItem: (__, compData) => {
			return compData?.resolvedSvg
				? getFontFamilyFontsFromSvg(compData.resolvedSvg.content).flatMap((x) => x)
				: EMPTY_ARRAY
		},
	}),
}
